module.exports = __webpack_public_path__ + "img/face.5a67825b.png";